module.exports = __webpack_public_path__ + "static/media/PUP.70c4e56b.png";